import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactsMaxLimitContainer = () => {
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/infoBox/AuthContactLimitBox`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/common/infoBox/PublicContactLimitBox`)
  });
};
export default ContactsMaxLimitContainer;